import { Component, ChangeDetectionStrategy, input, computed, inject, SecurityContext } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'widget-markdown',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="md-icerik" [innerHTML]="guvenliIcerik()"></div>
  `,
  styles: [`
    :host { display: block; }
    .md-icerik {
      font-size: 13px; line-height: 1.6; padding: 8px 12px;
      color: var(--py-metin, #262626); word-break: break-word;
    }
    :host ::ng-deep {
      h1 { font-size: 20px; font-weight: 700; margin: 12px 0 8px; }
      h2 { font-size: 17px; font-weight: 600; margin: 10px 0 6px; }
      h3 { font-size: 15px; font-weight: 600; margin: 8px 0 4px; }
      p { margin: 4px 0; }
      ul, ol { padding-left: 20px; margin: 4px 0; }
      li { margin: 2px 0; }
      code {
        background: var(--py-hover, rgba(0,0,0,0.05));
        padding: 1px 4px; border-radius: 3px; font-size: 12px;
        font-family: 'Fira Code', monospace;
      }
      strong { font-weight: 600; }
      em { font-style: italic; }
      a { color: #1890ff; text-decoration: none; }
      a:hover { text-decoration: underline; }
    }
  `],
})
export class MarkdownComponent {
  private sanitizer = inject(DomSanitizer);

  icerik = input('');

  guvenliIcerik = computed(() => {
    return this.sanitizer.sanitize(SecurityContext.HTML, this.icerik()) || '';
  });
}
